import React, { useEffect, useRef, useState } from 'react';
import Header from 'thesis-and-dissertations/layouts/app/components/Header';
import Footer from 'thesis-and-dissertations/layouts/app/components/Footer';
import { useParams, Link } from 'react-router-dom';
import Api from '../../helpers/api';
import handleApiError from 'thesis-and-dissertations/helpers/handleApiError';

import { Document, Page } from 'react-pdf'

import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

import './style.css'
import LoginDetail from './LoginDetail';
import AlertUpdateProfileModal from './AlertModal';

const api = new Api();

const ContentDetail = (props) => {
    const { id } = useParams()
    const paragraphRef = useRef(null);

    const [errors, setErrors] = useState({})
    const [loading, setLoading] = useState({})
    const [dataDetail, setDataDetail] = useState([])
    const [feedback, setFeedback] = useState([])
    const [categories, setCategories] = useState([])
    const [file, setFile] = useState('')
    const [formData, setFormData] = useState({ tesis_id: id })
    const [user, setUser] = useState({})
    const [showModal, setShowModal] = useState(false)

    const [numPages, setNumPages] = useState();
    const [pageNumber, setPageNumber] = useState(1);

    useEffect(() => {
        fetchDetail()
        fetchFeedback()
        fetchCategories()
        fetchThesisFile()
        setUser(JSON.parse(localStorage.getItem('user')))
    }, [])

    const handleShowUpdateProfileModal = (isShow) => {
        setShowModal(isShow)
    }

    const handleClickEmoticon = (emoticon) => {
        let comment = formData?.komentar ? `${formData?.komentar} ${emoticon}` : emoticon
        setFormData({ ...formData, komentar: comment })
    }

    const onDocumentLoadSuccess = (value) => {
        setNumPages(value.numPages);
    }

    const fetchCategories = (params = {}) => {
        setLoading({ ...loading, categories: true })
        api.getScientificField({ ...params })
            .then(response => {
                const data = response.data;
                setCategories(data)
                setLoading({ ...loading, categories: false })
            }).catch((error) => {
                const { data, status } = error.response
                setErrors(data?.meta?.error)
                setLoading({ ...loading, categories: false })
            })
    };

    const fetchDetail = () => {
        setLoading({ ...loading, detailThesis: true })
        api.getThesisDetail(id)
            .then(response => {
                const data = response.data.data;
                setDataDetail(data[0])
                setLoading({ ...loading, detailThesis: false })
            }).catch((error) => {
                const { data, status } = error.response
                setErrors(data?.meta?.error)
                setLoading({ ...loading, detailThesis: false })
                handleApiError(error)
            })
    };

    const fetchFeedback = () => {
        setLoading({ ...loading, dataFeedback: true })
        api.getThesisFeedback(id)
            .then(response => {
                const data = response.data.data;
                setFeedback(data)
                setLoading({ ...loading, dataFeedback: false })
            }).catch((error) => {
                const { data, status } = error.response
                setErrors(data?.meta?.error)
                setLoading({ ...loading, dataFeedback: false })
                handleApiError(error)
            })
    };

    const fetchThesisFile = () => {
        setLoading({ ...loading, thesisFile: true })
        api.getThesisFile(id)
            .then(response => {
                setFile(response.data.data[0].Dokumen)
                setLoading({ ...loading, thesisFile: false })
            }).catch((error) => {
                const { data, status } = error.response
                setErrors(data?.meta?.error)
                setLoading({ ...loading, thesisFile: false })
                handleApiError(error)
            })
    };

    const handleInput = (e, name) => {
        setFormData({ ...formData, [name]: e.target.value })
    }

    const storeFeedback = () => {
        setLoading({ ...loading, storeFeedback: true })
        api.storeThesisFeedback(formData)
            .then(response => {
                fetchFeedback()
                handleResetFeedback()
                setLoading({ ...loading, storeFeedback: false })
            }).catch((error) => {
                const { data, status } = error.response
                setErrors(data?.meta?.error)
                setLoading({ ...loading, storeFeedback: false })
                handleApiError(error)
            })
    };

    const handleResetFeedback = () => {
        setFormData({ tesis_id: id, komentar: '' })
        setErrors({})
    }

    const handleDetail = () => {
        setShowModal(true)
    }

    return (
        <>
            <AlertUpdateProfileModal showAlertUpdateModal={showModal} handleShowUpdateProfileModal={handleShowUpdateProfileModal} email={dataDetail?.email} />
            <div className='container-fluid p-0 overflow-hidden' style={{ backgroundColor: '#FAF9F5' }}>
                <Header />

                <div className='row px-15'>
                    <div className='row pt-10'>
                        <div className='col-md-9 mb-5'>
                            <div className='card'>
                                <div className='col-md-3 px-5 pb-4 border-bottom'>
                                    <Link
                                        to={'/content-search'} className='btn btn-sm mt-6 mb-1'>
                                        <span className='btn-label-icon'>
                                            <i className='fa fa-arrow-left pe-3'></i>Kembali
                                        </span>
                                    </Link>
                                </div>

                                <div className='card-body p-10'>
                                    <div>
                                        <span className='badge p-2 m-1' style={{ backgroundColor: '#C5E8E5', color: '#007478' }}>
                                            {dataDetail?.BidangKeilmuan ? dataDetail?.BidangKeilmuan : '-'}
                                        </span>
                                    </div>
                                    <p className='fw-bold pt-8 fs-4'>{dataDetail?.JudulTugasAkhir ? dataDetail?.JudulTugasAkhir : '-'}</p>
                                    <p className='fw-bold pt-5 fs-6'>ABSTRAK</p>
                                    <span className='text-justify pt-5'>{dataDetail?.Abstrak ? dataDetail?.Abstrak : '-'}</span>
                                </div>
                            </div>

                            {/* {file && user?.fullname ?
                            <>
                                <div className='row mt-6'>
                                    <Document
                                        file={`data:application/pdf;base64,${file}`}
                                        onLoadSuccess={onDocumentLoadSuccess}>
                                        <Page pageNumber={pageNumber} />
                                    </Document>
                                </div>

                                <div className='row mb-5 d-flex justify-content-center'>
                                    <button className='btn btn-sm col-lg-3 col-md-12 col-sm-12 col-xs-12 text-center pt-5'
                                        disabled={pageNumber === 1}
                                        onClick={() => setPageNumber(pageNumber - 1)}>
                                        <i>« Prev</i>
                                    </button>

                                    <div className='col-lg-3 col-md-12 col-sm-12 col-xs-12 text-center pt-5'>
                                        <p className='fw-bold'>
                                            Halaman {pageNumber} of {numPages}
                                        </p>
                                    </div>

                                    <button className='btn btn-sm col-lg-3 col-md-12 col-sm-12 col-xs-12 text-center pt-5'
                                        disabled={pageNumber === numPages}
                                        onClick={() => setPageNumber(pageNumber + 1)}>
                                        <i>» Next</i>
                                    </button>
                                </div>
                            </>
                            : null} */}
                        </div>

                        <div className='col-md-3'>
                            <div className='row px-3 ml-5'>
                                <div className='card'>
                                    <div className='px-5 py-8 border-bottom'>
                                        <p className='fw-bold'>Meta Data</p>
                                    </div>

                                    <div className='p-5'>
                                        <div className='mb-8'>
                                            <p className='fw-bold'>Author</p>
                                            <p>{dataDetail?.Author ? dataDetail?.Author : '-'}</p>
                                        </div>

                                        <div className='row'>
                                            <div className='col-md-6 mb-8'>
                                                <p className='fw-bold'>Tahun Publish</p>
                                                <p>{dataDetail?.TahunPublish ? dataDetail?.TahunPublish : '-'}</p>
                                            </div>
                                            <div className='col-md-6 mb-8'>
                                                <p className='fw-bold'>Bahasa</p>
                                                <p>{dataDetail?.Bahasa ? dataDetail?.Bahasa : '-'}</p>
                                            </div>
                                        </div>

                                        <div className='mb-8'>
                                            <p className='fw-bold'>Bidang Keilmuan / Subject</p>
                                            <p>{dataDetail?.BidangKeilmuan ? dataDetail?.BidangKeilmuan : '-'}</p>
                                        </div>

                                        <div className='mb-5'>
                                            <p className='fw-bold'>Tesis Lengkap</p>
                                            {/* <p>Bila Saudara menginginkan full version, sila langsung mengkontak penulis tesis/disertasi terkait</p> */}
                                            <button className='btn btn-primary btn-sm mt-3' onClick={handleDetail}>Detail</button>
                                            {/* <p>{dataDetail?.email ? dataDetail?.email : '-'}</p> */}
                                        </div>
                                    </div>

                                </div>
                            </div>

                            {/* COMMENTED: User login check removed - show content for all users */}
                            <div className='row px-3 ml-5 pt-6'>
                                <div className='card'>
                                    <div className='px-5 py-8 border-bottom'>
                                        <p className='fw-bold'>Topik Serupa</p>
                                    </div>

                                    <div className='px-5 mt-6 mb-10'>
                                        {categories?.map((item, key) => {
                                            return (
                                                <span key={key} className='badge badge-secondary p-2 m-1 rounded-pill'>{item?.bidang_keilmuan}</span>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>

                            <div className='row px-3 ml-5 pt-6 mb-7'>
                                        <div className='card'>
                                            <div className='px-5 py-8 border-bottom'>
                                                <p className='fw-bold'>Feedback</p>
                                            </div>

                                            <div ref={paragraphRef} style={{ height: '300px', overflow: 'scroll' }}>
                                                {feedback?.map((item, index) => {
                                                    return (
                                                        <div key={index}>
                                                            <div className='px-5 mt-6 mb-5'>
                                                                <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                                                                    <i className='bi bi-person-circle'></i>
                                                                    <p className='px-2'>{item?.user?.fullname}</p>
                                                                </div>
                                                                <p className='px-6 mt-3'>{item?.komentar}</p>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </div>

                                            {/* COMMENTED: Feedback form - thesis login feature disabled
                                            NOTE: Feedback submission requires backend modification to work without authentication
                                            {user?.fullname
                                                ?
                                                <div className='px-5 mt-6 mb-5'>
                                                    <div className='mb-2' style={{ display: 'inline-flex', alignItems: 'center' }}>
                                                        <i className='bi bi-person-circle'></i>
                                                        <p className='px-2'>{user?.fullname}</p>
                                                    </div>

                                                    <div className='mb-3 px-6'>
                                                        <img
                                                            src={require('../../assets/img/love.png')}
                                                            style={styles.emoticon}
                                                            className='m-1'
                                                            onClick={() => handleClickEmoticon('❤️')}
                                                        />
                                                        <img
                                                            src={require('../../assets/img/thumbs.png')}
                                                            style={styles.emoticon}
                                                            className='m-1'
                                                            onClick={() => handleClickEmoticon('👍')}
                                                        />
                                                        <img
                                                            src={require('../../assets/img/eye-love.png')}
                                                            style={styles.emoticon}
                                                            className='m-1'
                                                            onClick={() => handleClickEmoticon('😍')}
                                                        />
                                                        <img
                                                            src={require('../../assets/img/clock.png')}
                                                            style={styles.emoticon}
                                                            className='m-1'
                                                            onClick={() => handleClickEmoticon('🕢')}
                                                        />
                                                    </div>

                                                    <div className='px-6 mb-4'>
                                                        <textarea
                                                            onChange={value => handleInput(value, 'komentar')}
                                                            className='form-control mb-5'
                                                            value={formData?.komentar}></textarea>
                                                        {errors?.komentar ? <p className='text-danger mb-3'>{errors?.komentar}</p> : null}

                                                        <button
                                                            onClick={() => storeFeedback()}
                                                            disabled={loading?.storeFeedback}
                                                            type='button'
                                                            className='btn btn-primary btn-sm rounded-pill mt-2'>
                                                            {loading?.storeFeedback ? 'Loading...' : 'Komentari'}
                                                        </button>

                                                        <button
                                                            onClick={handleResetFeedback}
                                                            type='button'
                                                            className='btn btn-secondary btn-sm rounded-pill mx-2 mt-2'>
                                                            Batal
                                                        </button>
                                                    </div>
                                                </div>
                                                :
                                                null
                                            } */}
                                        </div>
                                    </div>
                        </div>
                    </div>
                </div>

                {/* COMMENTED: Always show footer */}
                {/* {user?.fullname ? <Footer /> : null} */}
                <Footer />

                {/* COMMENTED: Hide login prompt at bottom */}
                {/* {!user?.fullname
                    ?
                    <div className='fixed-bottom'>
                        <LoginDetail />
                    </div>
                    :
                    null} */}
            </div>
        </>
    );
};

const styles = {
    emoticon: {
        width: '15px',
        height: '15px',
        cursor: 'pointer'
    },
}

export default ContentDetail;